'use strict';
(function () {
  var _controller = 'levels.controller';
  angular.module('pentaApp').controller(_controller, controller);
  controller.$inject = ['$scope', '$q', '$injector', 'clubRules.resource', 'clubBenefit.resource', '$timeout', 'image.resource'];
  function controller($scope, $q, $injector, clubRulesResource, clubBenefitResource, $timeout, imageResource) {
    var clubLevelResource = $scope.$root.employeeApp ? $injector.get('clubLevelInfo.resource') : $injector.get('clubLevel.resource')
    /// METHODS 
    $scope.imageResource = imageResource;

    /// VARS
    $scope.active = "ADD" //- inicia el div sumar activo
    $scope.levelData = {};
    $scope.rulesDataAdd = [];
    $scope.historyData = [];
    $scope.maxLevel = false; //- si ya se obtuvo el maximo nivel

    var filter = {
      _controller: _controller,
      _select: ['*'],
      _paginate: false
    }
    if($scope.$root.employeeApp) filter.userCredential = profile.userId;


    // WATCHERS
    $scope.$on('$destroy', onDestroy);

    /// INIT
    init();
    if(!$scope.$root.employeeApp && !profile._id) {
      $injector.get('bottomLogin.modal').open({title: i18next.t('Debes iniciar sesión')})
    }


    /////////////////////

    function init() {
      var levelData = clubLevelResource.get(filter)
      var rulesData = clubRulesResource.query({ 
        _controller: _controller, 
        _select: ['*'], 
        userType: $scope.$root.employeeApp ? 'EMPLOYEE' : 'CLIENT',
      })
      var benefitData = clubBenefitResource.query(filter)

      $q
        .all([levelData.$promise, rulesData.$promise, benefitData.$promise])
        .then(function () {
          //- obtener informacion del nivel actual
          $scope.levelData = levelData;
          //- obtener reglas para sumar
          if (rulesData.length) $scope.rulesDataAdd = rulesData.filter(function (f) { return f.direction === 'IN' })
          if(!levelData.currentLevel) return;
          //- obtener historial de beneficios
          $scope.historyData = benefitData;
          $scope.nextBenefitToExipire = benefitData.filter(function(f){if(f.expireAt) f.expireAt = new Date(f.expireAt); return !!f.expireAt})
                                                   .sort(function(a,b){return a.expireAt - b.expireAt})[0];
          /// Obtengo siguiente nivel
          $scope.levelData.nextLevel = $scope.levelData.levels.find(function (f) { return f.requiredPoints > $scope.levelData.currentLevel.requiredPoints })
          //- Progressive bar cfg
          var bar = {
            current: levelData.currentLevel.requiredPoints,
            next: levelData.nextLevel && levelData.nextLevel.requiredPoints || null,
            total: levelData.totalPoints || 0
          }
          getDataProgressBar(bar)
        })
        .catch(function (err) { if (err) throw new PentaError(err) })
    }

    function getDataProgressBar(bar) {
      if (!bar.next) $scope.maxLevel = true; //- si no hay siguiente nivel disponible muestra span nivel maximo
      $scope.progressBar = 0;
      var progressBar;
      if (bar.next) progressBar = ((bar.total - bar.current) * 100) / bar.next; //- obtiene el valor primario de la progress bar
      else progressBar = 100;
      //- animacion de la barra
      $timeout(function () {
        $scope.progressBar = progressBar;
      })
    }

    function onDestroy() {
      $scope.$root.abortRequests(_controller);
    }

    //// FIN CONTROLLER
  }
})();
